<template>
    <div id="main">
        <LoadingCommon v-if="isLoadingScreen" />
        <div class="error-settings" v-else-if="settingError !== ''">{{ settingError }}</div>
        <template v-else>
            <NavCommon />
            <router-view />
            <Confirm />
        </template>
    </div>
</template>
<script>
import jwt_decode from 'jwt-decode'
import Confirm from '@/components/common/confirm.vue'
import LoadingCommon from '@/components/common/loading.vue'
import NavCommon from '@/components/nav/index.vue'
import languageMixins from '@/mixins/language/language-mixins'

import { getParamQueryTheme, increaseStakePrice, isStrEmpty } from '@/utils/utils'
import {
    deleteAccount,
    deleteCurrency,
    deleteGameSlug,
    deleteToken,
    setAccount,
    setCurrency,
    setDataLanguage,
    setGameSlug,
    setLanguage,
    setToken,
} from './services/axios'
import gamesService from './services/games.service'

const IS_DEV = process.env.VUE_APP_DEV

export default {
    mixins: [languageMixins],

    components: { Confirm, LoadingCommon, NavCommon },
    data() {
        return {
            isChecklogin: false,
            screenWidth: window.innerWidth,
            isLoadingScreen: true,
            settingError: '',
        }
    },
    watch: {
        screenWidth(value) {
            if (value <= 768) {
                this.$store.state.isScreenMobile = true
            } else {
                this.$store.state.isScreenMobile = false
            }
        },
    },
    created() {
        this.fetchData()
        if (this.screenWidth <= 768) {
            this.$store.state.isScreenMobile = true
            this.$store.state.isScreenPhone = this.screenWidth <= 480 ? true : false
        } else {
            this.$store.state.isScreenMobile = false
        }
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('message', this.getMessage)
    },
    mounted() {
        if (!isStrEmpty(getParamQueryTheme('account'))) {
            setAccount(getParamQueryTheme('account'))
        } else {
            deleteAccount()
        }

        if (!isStrEmpty(getParamQueryTheme('token'))) {
            setToken(getParamQueryTheme('token'))
            this.checkLogin(getParamQueryTheme('token'))
        } else {
            deleteToken()
            this.$store.state.isLogin = false
        }

        if (!isStrEmpty(getParamQueryTheme('currency'))) {
            setCurrency(getParamQueryTheme('currency'))
        } else {
            deleteCurrency()
        }

        if (!isStrEmpty(getParamQueryTheme('gameSlug'))) {
            setGameSlug(getParamQueryTheme('gameSlug'))
        } else {
            deleteGameSlug()
        }

        if (!isStrEmpty(getParamQueryTheme('lang'))) {
            setLanguage(getParamQueryTheme('lang'))
            this.fetchDataSettings(getParamQueryTheme('lang'))
        } else {
            setLanguage('en')
            this.fetchDataSettings('en')
        }
    },
    methods: {
        getMessage(event) {
            // if (event.data.command === 'set_data') {
            //     if (!isStrEmpty(event.data.data.token)) {
            //         setToken(event.data.data.token)
            //         this.checkLogin(event.data.data.token)
            //     } else {
            //         deleteToken()
            //         this.$store.state.isLogin = false
            //     }
            //     if (!isStrEmpty(event.data.data.account)) {
            //         setAccount(event.data.data.account)
            //         this.fetchDataSettings()
            //     } else {
            //         deleteAccount()
            //     }
            //     if (!isStrEmpty(event.data.data.currency)) {
            //         setCurrency(event.data.data.currency)
            //     } else {
            //         deleteCurrency()
            //     }
            //     if (!isStrEmpty(event.data.data.gameSlug)) {
            //         setGameSlug(event.data.data.gameSlug)
            //     } else {
            //         deleteGameSlug()
            //     }
            // }
        },
        fetchData() {
            const betslip = !isStrEmpty(localStorage.getItem('betslip'))
                ? JSON.parse(localStorage.getItem('betslip'))
                : []
            const dataActive = !isStrEmpty(localStorage.getItem('dataActive'))
                ? JSON.parse(localStorage.getItem('dataActive'))
                : []
            this.$store.state.betslip = betslip
            this.$store.state.dataActive = dataActive
        },
        handleResize() {
            this.screenWidth = window.innerWidth
        },

        async fetchDataSettings(lang) {
            try {
                const resp = await gamesService.getAllSetting(lang)

                if (resp.settings.status === 'success' && resp.locale.status === 'success') {
                    const lang = resp.locale.data.message
                    const setting = resp.settings.data

                    const stakePrice = increaseStakePrice(parseInt(setting.min_amount))
                    this.$store.state.stakePrice = stakePrice
                    this.$store.state.accountSetting = setting
                    setDataLanguage(JSON.stringify(lang))

                    const skin = !isStrEmpty(setting.base_skin) ? setting.base_skin : 'default'
                    await import('@/public/theme/default/scss/variable/' + skin + '/_variable.scss')
                } else {
                    this.settingError = resp.settings?.message ? resp.lang?.message : ''
                }
            } catch (error) {
                this.settingError = error.message || ''
                if (parseInt(IS_DEV)) {
                    console.log(error)
                }
            } finally {
                this.isLoadingScreen = false
            }
        },

        async checkLogin(token) {
            try {
                const decodedToken = jwt_decode(token)
                this.$store.state.isLogin =
                    !isStrEmpty(decodedToken.account_id.toString()) &&
                    !isStrEmpty(decodedToken.customer_id) &&
                    !isStrEmpty(decodedToken.toString())
            } catch (error) {
                this.$store.state.isLogin = false
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/main.scss';
</style>
